import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { CantidadArticulos } from '../../../../../../core/model/DataOrder';
import { CheckoutService } from '../../utils/services/checkout.service';
import { CartService } from '../../../../../../services/generar-pedido/cart/cart.service';
import { LoginService } from '../../../../../../services/login/login.service';
import { DataAddress } from '../../../../../../views/clientes/model/DataAddress';
import { EmpresaService } from '../../../../../../services/Empresa/Empresa.service';

@Component({
  selector: 'app-metodo-entrega-sucursal',
  templateUrl: './metodo-entrega-sucursal.component.html',
  styleUrls: ['./metodo-entrega-sucursal.component.scss']
})
export class MetodoEntregaSucursalComponent implements OnInit {
  isMobile: boolean;
  @Input() title: string;
  @Input() isCedis: boolean;
  @Input() items: CantidadArticulos;
  // @Output() radioOpcionMetodoEntrega: EventEmitter<any> = new EventEmitter<any>();
  public tipoEntrega = 'sucursal';
  public optionFormGroup: FormGroup;
  public precioEnvio: number = 0;//140;
  public precioEnvioDomicilio: number = 50;

  private unsubscribe$ = new Subject<void>();
  empresaId: number;

  constructor(
    private formBuilder: FormBuilder,
    private service: CheckoutService,
    private cartService: CartService,
    private login: LoginService,
    private empresaService: EmpresaService
  ) {
    this.empresaId = this.empresaService.getEmpresaId();
  }

  ngOnInit(): void {
    const screenWidth = window.innerWidth;
    this.isMobile = screenWidth < 770;

    this.optionFormGroup = this.formBuilder.group({
      tipoEntrega: [''],
    });
    this.updateForm();
    this.valueChangesForm();
    const PG = this.login.getDataClientePedido().es_publicogeneral === 'SI'; // valida si es cliente publico general.
    const tpEntrega = localStorage.getItem('tipo-entrega-sucursal'); // Credito o contado
    this.optionFormGroup.get('tipoEntrega').setValue(PG ? 'envio' : (tpEntrega !== null ? tpEntrega : 'sucursal'));
    this.chekPrecioEnvio();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public getValue = (): string => {
    return this.optionFormGroup.get('tipoEntrega').value;
  };
  private valueChangesForm() {
    this.optionFormGroup.get('tipoEntrega').valueChanges.pipe(debounceTime(200),
      takeUntil(this.unsubscribe$)
    ).subscribe(value => {
      let mensaje = '';
      let direccion: DataAddress;
      let direccionSeleccionada: boolean = false;
      if (value == 'envio' || value == 'envioDomicilio') {
        const addres: DataAddress = this.isCedis ? JSON.parse(localStorage.getItem('address-envio-cedis')) : JSON.parse(localStorage.getItem('address-envio'));
        direccion = addres;
        mensaje = addres !== null ? 'Direccion seleccionada' : (value === 'envio' ? 'Para continuar debe selecciona una dirección de envio.' : 'Para continuar, debe seleccionar una dirección de envío a domicilio.');
        direccionSeleccionada = addres !== null ? true : false; // Si no a seleccionado una direccion
      } else {
        localStorage.removeItem('address-envio')
      }
      this.service.addEnvioMercanciaSucursal$(direccionSeleccionada, value, mensaje, direccion);
    });
  }
  private chekPrecioEnvio() {
    this.cartService.precioEnvio$.pipe(takeUntil(this.unsubscribe$), switchMap((precioEnvio: number) => {
      // Se actualiza el precio cuando el servicio de getCredito y cuando se manda a llamar las direcciones.
      this.precioEnvio = precioEnvio;
      return this.service.getEnvioMercanciaSucursal$().pipe(takeUntil(this.unsubscribe$));
    })).subscribe((envioMercancia: any) => {
      // console.log('Envio de mercancia sucursal',envioMercancia);
      if (envioMercancia) {
        localStorage.setItem('tipo-entrega-sucursal', envioMercancia.opcionEnvio);
      }
    });
  }
  private updateForm() {
    this.service.getformularioCheckout$().pipe(takeUntil(this.unsubscribe$)).subscribe((activo: Boolean) => {
      if (activo) {
        this.optionFormGroup.disable();
      } else {
        this.optionFormGroup.enable();
      }
    });
  }
}
